<template>
  <!-- Vollbild-Lightbox: Klick irgendwo schliesst; Bild bleibt innerhalb des Bildschirmrands -->
  <div v-if="url" class="image-zoom" @click="$emit('close')">
    <img :src="url" alt="" />
    <!-- eigener Button statt md-button: dessen Theme zeichnete ein weisses X auf hellgrauem Grund (Trello 28.10.) -->
    <button type="button" class="image-zoom__close" :title="$t('products.close')" @click.stop="$emit('close')">
      <span class="material-icons">close</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "ImageZoom",
  props: {
    url: { type: String, default: null },
  },
};
</script>

<style scoped>
.image-zoom {
  position: fixed;
  inset: 0;
  z-index: 10001;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
}
.image-zoom img {
  max-width: calc(100vw - 64px);
  max-height: calc(100vh - 64px);
  object-fit: contain;
  border-radius: 4px;
  background: #fff;
}
.image-zoom__close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0 none;
  border-radius: 4px;
  background: #333;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}
.image-zoom__close:hover {
  background: #000;
}
.image-zoom__close .material-icons {
  font-size: 26px;
  line-height: 1;
}
</style>
